<template>
    <div class="contact-search-wrapper" v-click-outside="closeResults">
        <v-text-field :label="label"
                      v-model="searchTerm"
                      :loading="searching"
                      clearable
                      hide-details
                      @click:clear="clearSelection"
                      @focus="onFocus"
                      autocomplete="off"></v-text-field>
        <div v-if="showResults" class="contact-search-results elevation-4">
            <v-list lines="one" density="compact">
                <v-list-item v-for="option in searchResults"
                             :key="option.id"
                             :value="option"
                             @click="selectContact(option)"
                             color="primary">
                    <template v-slot:prepend>
                        <v-icon icon="mdi-circle-outline" size="small"></v-icon>
                    </template>
                    <template v-slot:title>
                        <span v-html="formatSearchName(option.name, searchTerm)"></span>
                    </template>
                    <template v-slot:subtitle>
                        <span v-if="option.accountsEmail"><i>Email: </i><span v-html="formatSearchName(option.accountsEmail, searchTerm)"></span></span>
                        <span v-if="option.phone" class="ml-2"><i>Phone: </i><span v-html="formatSearchName(option.phone, searchTerm)"></span></span>
                    </template>
                </v-list-item>
                <v-list-item v-if="allowAdd && searchResults.length === 0 && !searching">
                    <v-list-item-title class="text-medium-emphasis text-body-2">No results found.</v-list-item-title>
                </v-list-item>
            </v-list>
            <div v-if="allowAdd" class="pa-2 border-t">
                <v-btn color="primary" @click="$emit('add', searchTerm)" prepend-icon="mdi-plus" size="small" variant="text">
                    ADD CUSTOMER
                </v-btn>
            </div>
        </div>
        <div v-if="modelValue" class="mt-1">
            <v-chip closable color="primary" variant="tonal" @click:close="clearSelection">{{ modelValue.name }}</v-chip>
        </div>
    </div>
</template>
<style scoped>
    .contact-search-wrapper {
        position: relative;
    }
    .contact-search-results {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        z-index: 9999;
        background: white;
        border-radius: 4px;
        max-height: 320px;
        overflow-y: auto;
    }
    :deep(.highlight-text) {
        background-color: #FFF176;
        font-weight: bold;
    }
</style>
<script>
    import { formatSearchName } from '../mixins/searchMixins';
    export default {
        name: "ContactSearchInput",
        emits: ['update:modelValue', 'add'],
        props: {
            modelValue: {
                type: Object,
                default: null
            },
            label: {
                type: String,
                default: 'Search for Customer...'
            },
            allowAdd: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                searchTerm: '',
                searching: false,
                searchResults: [],
                searchTimer: null,
                resultsOpen: false
            };
        },
        computed: {
            showResults() {
                return this.resultsOpen && !this.modelValue && (this.searchResults.length > 0 || (this.allowAdd && this.searchTerm && this.searchTerm.length > 2 && !this.searching));
            }
        },
        watch: {
            searchTerm(val) {
                clearTimeout(this.searchTimer);
                if (val && val.length > 2 && !this.modelValue) {
                    this.searchTimer = setTimeout(this.search, 150);
                } else {
                    this.searchResults = [];
                }
            },
            modelValue(val) {
                if (!val) {
                    this.searchTerm = '';
                    this.searchResults = [];
                    this.resultsOpen = false;
                }
            }
        },
        methods: {
            formatSearchName,
            onFocus() {
                this.resultsOpen = true;
            },
            closeResults() {
                this.resultsOpen = false;
            },
            search() {
                this.searching = true;
                this.$api.get('contacts/?searchTerm=' + encodeURIComponent(this.searchTerm))
                    .then(res => {
                        this.searchResults = res.data.items;
                        this.searching = false;
                    })
                    .catch(() => {
                        this.searching = false;
                    });
            },
            selectContact(option) {
                this.$emit('update:modelValue', option);
                this.searchTerm = '';
                this.searchResults = [];
                this.resultsOpen = false;
            },
            clearSelection() {
                this.$emit('update:modelValue', null);
                this.searchTerm = '';
                this.searchResults = [];
                this.resultsOpen = false;
            }
        }
    };
</script>
